import React, { useState } from 'react';
import { FileSearch, GitCompare, Database, Scale } from 'lucide-react';
import FinanceiroFitaConsulta      from './FinanceiroFitaConsulta';
import FinanceiroFitaConciliacao   from './FinanceiroFitaConciliacao';
import FinanceiroFitaImportacao    from './FinanceiroFitaImportacao';
import FinanceiroFitaSobraFalta    from './FinanceiroFitaSobraFalta';

const ABAS = [
    { id: 'consulta',     label: 'Consulta',                    icon: FileSearch  },
    { id: 'importacao',   label: 'Importação',                  icon: Database    },
    { id: 'conciliacao',  label: 'Conciliação Resumo de Venda', icon: GitCompare  },
    { id: 'sobrafalta',   label: 'Débito / Crédito',            icon: Scale       },
];

const FinanceiroFita = () => {
    const [abaAtiva, setAbaAtiva] = useState('consulta');

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>

            {/* SUB-NAVEGAÇÃO */}
            <div style={{
                display: 'flex', flexWrap: 'wrap', gap: '8px',
                backgroundColor: '#f8fafc', padding: '6px',
                borderRadius: '10px', border: '1px solid #e2e8f0',
                width: 'fit-content',
            }}>
                {ABAS.map(aba => {
                    const ativo = abaAtiva === aba.id;
                    return (
                        <button
                            key={aba.id}
                            onClick={() => setAbaAtiva(aba.id)}
                            style={{
                                display: 'flex', alignItems: 'center', gap: '7px',
                                padding: '8px 18px', borderRadius: '7px',
                                border: ativo ? '1px solid #16a39c' : '1px solid transparent',
                                backgroundColor: ativo ? '#fff' : 'transparent',
                                color: ativo ? '#0d7a74' : '#64748b',
                                fontWeight: ativo ? '800' : '600',
                                fontSize: '13px',
                                cursor: 'pointer',
                                transition: 'all 0.15s',
                                boxShadow: ativo ? '0 1px 4px rgba(13,122,116,0.12)' : 'none',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            <aba.icon size={15} />
                            {aba.label}
                        </button>
                    );
                })}
            </div>

            {/* CONTEÚDO DA ABA */}
            {abaAtiva === 'consulta'    && <FinanceiroFitaConsulta    />}
            {abaAtiva === 'conciliacao' && <FinanceiroFitaConciliacao />}
            {abaAtiva === 'importacao'  && <FinanceiroFitaImportacao  />}
            {abaAtiva === 'sobrafalta'  && <FinanceiroFitaSobraFalta  />}
        </div>
    );
};

export default FinanceiroFita;
